<!-- 首发阵容+替补阵容  -->
<template>
  <div class="complex_doubleTeam" :class="themeClass" v-if="datas">
    <span class="lineupOpt_header">
      <span
        class="lineup_title"
        v-text="themeItem_titleList[0] ? themeItem_titleList[0] : ''"
      ></span>
      <span class="select_opt">
        <slot name="selectOpt"></slot>
      </span>
      <span class="share_opt">
        <slot name="sharingMenu"></slot>
      </span>
    </span>
    <template v-if="lineupDoubleTeam_renderData">
      <Lineup_horizontalPGA
        :datas="lineupDoubleTeam_renderData"
        :currThemeObj="currThemeObj"
        :detailPathName="detailPathName"
        :themeClass="themeClass"
        :isScore="isScore"
        :homeAwayArr="homeAwayArr"
      ></Lineup_horizontalPGA>
    </template>
    <div
      class="lineup_sub"
      v-if="
        lineupSubList_renderData &&
        themeItem_titleList &&
        themeItem_titleList[1]
      "
    >
      <span class="lineup_title" v-text="themeItem_titleList[1]"></span>
      <Lineup_subList
        :datas="lineupSubList_renderData"
        :currThemeObj="currThemeObj"
        :detailPathName="detailPathName"
        :shrinkRowNum="shrinkRowNum ? shrinkRowNum : themeClass ? 1000 : 6"
        :themeClass="themeClass"
        :homeAwayArr="homeAwayArr"
      ></Lineup_subList>
    </div>
  </div>
</template>
<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import Lineup_horizontalPGA from '@components/football/html/HTML_LINEUP/lineup_horizontalPGA.vue'
import Lineup_subList from '@components/football/html/HTML_LINEUP/lineup_subList.vue'
export default {
  name: 'complex_doubleTeam',
  mixins: [cup_base_data_mixin],
  components: {
    Lineup_horizontalPGA,
    Lineup_subList,
  },
  props: {
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [], //用它判断是展示一只球队还是2支球队
        data: {
          dataList: [], //这里面默认必须有2个元素
        },
        statisticsModels: [],
      }),
    },
    themeItem_titleList: {
      type: Array,
      default: () => {
        return ['', '']
      },
    },
    themeClass: {
      type: String,
      default: '',
    },
    detailPathName: {
      type: String,
      default: '',
    },
    isScore: {
      // 是否【评分】主题
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lineupDoubleTeam_renderData: null,
      lineupSubList_renderData: null,
      teamScoreList: null,
      shrinkRowNum: null, //单独控制展示几行的个数
      homeAwayArr: null, //给替补名单 ||替补阵容 用的
    }
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formatDatasHandler(newVal)
        }
      },
      immediate: true,
      // deep: true,
    },
  },
  methods: {
    formatDatasHandler(datas) {
      console.debug('formatDatasHandler:', datas)
      const teamKeyList = ['home', 'away']
      let renderData = JSON.parse(JSON.stringify(datas))
      let lineupDoubleTeam_renderData = JSON.parse(JSON.stringify(datas))
      let lineupSubList_renderData = JSON.parse(JSON.stringify(datas))
      let teamScoreList = [[], []]
      let lineupDoubleTeam_dataList = [[], []]
      let lineupSubList_dataList = [[], []]
      this.shrinkRowNum = null // 恢复默认展示的个数
      if (
        renderData &&
        renderData.objectInfo &&
        renderData.objectInfo.length === 1
      ) {
        // 单支球队，无论主客队都放在 dataList[0] 里面
        this.shrinkRowNum = 1000 //单支球队不需要【展开|收起】按钮
        let new_subDataList = []
        renderData.data.dataList.forEach((playerArr, pIndex) => {
          if (playerArr && playerArr.length > 0) {
            this.teamType = teamKeyList[pIndex]
            playerArr.forEach((player) => {
              if (player.formationPlace && player.playerId - 0 > 0) {
                lineupDoubleTeam_dataList[pIndex].push(player)
              }
              if (!player.formationPlace && player.playerId - 0 > 0) {
                new_subDataList.push(player)
              }
              if (player.playerId - 0 === -1) {
                teamScoreList[pIndex].push(player)
              }
            })
          }
        })
        new_subDataList.forEach((player, pIndex) => {
          lineupSubList_dataList[pIndex % 2].push(player)
        })
        this.homeAwayArr = [this.teamType, this.teamType]
      } else if (
        renderData &&
        renderData.objectInfo &&
        renderData.objectInfo.length === 2
      ) {
        this.homeAwayArr = ['home', 'away']
        renderData.data.dataList.forEach((playerArr, pIndex) => {
          if (playerArr && playerArr.length > 0) {
            playerArr.forEach((player) => {
              if (player.formationPlace && player.playerId - 0 > 0) {
                lineupDoubleTeam_dataList[pIndex].push(player)
              }
              if (!player.formationPlace && player.playerId - 0 > 0) {
                lineupSubList_dataList[pIndex].push(player)
              }
              if (player.playerId - 0 === -1) {
                teamScoreList[pIndex].push(player)
              }
            })
          }
        })
      }
      lineupDoubleTeam_renderData.data.dataList = lineupDoubleTeam_dataList
      lineupSubList_renderData.data.dataList = lineupSubList_dataList

      this.lineupDoubleTeam_renderData = lineupDoubleTeam_renderData
      this.lineupSubList_renderData = lineupSubList_renderData
      this.teamScoreList = teamScoreList
      console.debug('complex_doubleTeam:', this.lineupDoubleTeam_renderData)
    },
  },
}
</script>
<style lang="scss" scoped>
.complex_doubleTeam {
  margin-bottom: 3vw;
  width: 100%;
  height: auto;
  border: 1px solid var(--mixtmt_greyColor7);
  border-radius: 1.042vw;
  &.onlyDisplay {
    border: 0;
    border-radius: 0;
    margin-bottom: 0;
    .lineupOpt_header {
      padding: 0.694vw;
    }
  }
  .lineupOpt_header {
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.388vw 1.388vw 2.083vw 1.388vw;
    .lineup_title {
      width: 40%;
      font-weight: bold;
      font-size: 1.66vw;
    }
    .share_opt {
      flex: 1;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
    }
    .select_opt {
      width: 20%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
    }
  }
  .lineup_sub {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding-top: 1.388vw;
    .lineup_title {
      width: 100%;
      font-weight: bold;
      font-size: 1.66vw;
      padding: 0 1.388vw 0.694vw 1.388vw;
    }
  }
}
</style>
